import {API_URL} from '@env'

export default {
    BASE_URL: API_URL
};
